import { fattPayClient } from "./FattPayClient";
import cardXClient from "./CardXClient";
import Payment from "./Payment";
import { PaymentType } from "./PaymentType";
import { configService } from "../Config/ConfigService";
import { booleanify } from "../../Components/Shared/Utility/Booleanify";
import { affirmClient } from "./AffirmClient";

export enum CreditCardClientLibrary { 
    None = 0,
    CardX = 1,
    FattPay = 2
}

export enum PaymentProcesserEnum {
    None = 0,
    Stax = 1,
    CardX = 2,
    Affirm = 3
}

export interface IPaymentProcessor
{
    getPaymentProcessorId() : PaymentProcesserEnum;
    tokenize(payment: Payment): Promise<Payment>;
}

export async function getCreditCardProcessor() : Promise<CreditCardClientLibrary> {
    const useCardXFlag = (await configService.getConfiguration()).FeatureFlags.UseCardXPaymentProcessor;
    const useCardX = (typeof useCardXFlag === "string") ? booleanify(useCardXFlag) : useCardXFlag;

    return useCardX ?  CreditCardClientLibrary.CardX : CreditCardClientLibrary.FattPay;
}

const isCreditCardPaymentType = (paymentType : PaymentType) => paymentType == PaymentType.CreditCardVisa || paymentType == PaymentType.Discover || paymentType == PaymentType.MasterCard || paymentType == PaymentType.AmericanExpress;

export function getPaymentProcessorForPaymentType(creditCardLibrary : CreditCardClientLibrary, paymentType : PaymentType) : IPaymentProcessor {

    if (isCreditCardPaymentType(paymentType)) 
    {
        switch (creditCardLibrary){
            case CreditCardClientLibrary.CardX: {
                return cardXClient;
            }
            case CreditCardClientLibrary.FattPay: {
                return fattPayClient;
            }
            default:
            {
                throw new Error("No credit card client library available");
            }
        }
    }

    switch (paymentType)
    {
        case PaymentType.Affirm: 
        {
            return affirmClient;
        }
        case PaymentType.ECheckAch:
        {
            return fattPayClient;
        }
        default:
        {
            throw new Error("No payment processor");
        }
    }
}

